export class InvoiceNumbersFormat {
    static readonly FourDigitYear: string = "%YYYY%";
    static readonly TwoDigitYear: string = "%YY%";
    static readonly TwoDigitMonth: string = "%MM%";
    static readonly TwoDigitSequenceNumber: string = "%NN%";
    static readonly FourDigitSequenceNumber: string = "%NNNN%";
    static readonly SixDigitSequenceNumber: string = "%NNNNNN%";
}

export class InvoiceNumberType {
    InvoiceFormat: string | null = null;
    InvoiceNextNumber: number = 0;
}
